<script lang="ts" setup>
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'

const { primaryBgColor } = useRecipientLanding()
</script>

<template>
  <div class="envelope-back rounded-b-v2lg" :style="{ color: primaryBgColor, width: '305px' }">
    <!-- eslint-disable vue/max-len -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="15.027972027972028 0 277.6596736596737 339.38399999999996"
    >
      <g filter="url(#filter0_d_601_47607)">
        <path fill="#F9F9F9" d="M280.486 337.482C286.784 337.482 291.889 332.377 291.889 326.08V132.881L14.556 132.882V326.08C14.556 332.377 19.6609 337.482 25.9582 337.482H280.486Z"/>
      </g>
      <path fill="#F9F9F9" d="M291.889 132.878L171.766 17.7692C161.399 7.83537 145.046 7.83536 134.679 17.7692L14.556 132.878H291.889Z"/>
      <mask id="path-3-inside-1_601_47607" fill="white">
        <path d="M163.875 4.32787C157.706 -1.44262 148.736 -1.44263 142.567 4.32787L20.9241 118.116C16.8608 121.916 14.5547 127.312 14.5547 132.876H31.5427L31.5403 128.73L151.889 16.8399C152.66 16.1186 153.782 16.1186 154.553 16.8399L274.898 128.73L274.899 132.876H291.887C291.887 127.312 289.581 121.916 285.518 118.116L163.875 4.32787Z"/>
      </mask>
      <path mask="url(#path-3-inside-1_601_47607)" stroke-width="2" stroke="white" fill="currentColor" d="M163.875 4.32787C157.706 -1.44262 148.736 -1.44263 142.567 4.32787L20.9241 118.116C16.8608 121.916 14.5547 127.312 14.5547 132.876H31.5427L31.5403 128.73L151.889 16.8399C152.66 16.1186 153.782 16.1186 154.553 16.8399L274.898 128.73L274.899 132.876H291.887C291.887 127.312 289.581 121.916 285.518 118.116L163.875 4.32787Z"/>
      <defs>
        <filter
          id="filter0_d_601_47607"
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="233.107"
          width="305.838"
          y="124.329"
          x="0.303875"
        >
          <feFlood result="BackgroundImageFix" flood-opacity="0"/>
          <feColorMatrix result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" type="matrix" in="SourceAlpha"/>
          <feOffset dy="5.70111"/>
          <feGaussianBlur stdDeviation="7.12638"/>
          <feComposite operator="out" in2="hardAlpha"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" type="matrix"/>
          <feBlend result="effect1_dropShadow_601_47607" in2="BackgroundImageFix" mode="normal"/>
          <feBlend result="shape" in2="effect1_dropShadow_601_47607" in="SourceGraphic" mode="normal"/>
        </filter>
      </defs>
    </svg>

  </div>
</template>
